<template>
  <!-- 头部整体盒子 -->
  <header class="header scrolling-header" data-scrolling-animations="true">
    <nav id="nav" class="navbar navbar-default navbar-fixed-top" role="navigation">
      <div class="container relative-nav-container">
        <a class="toggle-button visible-xs-block" data-toggle="collapse" data-target="#navbar-collapse">
          <i class="fa fa-navicon"></i>
        </a>
        <a class="navbar-brand scroll" href="home.html">
          <img class="normal-logo hidden-xs" src="../assets/img/logo.png" width="280" height="40" alt="logo" />
          <img class="scroll-logo hidden-xs" src="../assets/img/logo-dark.png" width="280" height="40" alt="logo" />
          <img class="scroll-logo visible-xs-block" src="../assets/img/logo-free.png" width="50" height="40"
            alt="logo" />
        </a>
        <!-- <ul class="nav navbar-nav navbar-right nav-icons wrap-user-control">
          <li>
            <a id="search-open" href="#fakelink"><i class="fa fa-search"></i></a>
          </li>
          <li class="open-signup">
            <a href="#fakelink"><i class="fa fa-user"></i></a>
          </li>
        </ul> -->
        <div class="navbar-collapse collapse floated" id="navbar-collapse">
          <menu-tree :menuData="menuData"></menu-tree>
        </div>
      </div>
      <div class="navbar-search">
        <div class="container">
          <form>
            <div class="input-group">
              <input type="text" placeholder="输入搜索项..." class="form-control" autocomplete="off" />
              <span class="input-group-btn">
                <button type="reset" class="btn search-close" id="search-close">
                  <i class="fa fa-close"></i>
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import { mapState } from "vuex";
import MenuTree from "./MenuTree.vue";

export default {
  name: "Header",
  components: {
    MenuTree,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      menuData: (state) => state.home.categoryList,
    }),
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue